import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import Header_Supervisor from "../../Components/Header_Supervisor";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Components/Company.css';

import { BASE_URL, paybridge_Url } from '../../Config';

const Supervisor_Dashboard = () => {

  const [data, setData] = useState({
    userId: "",
    name: "",
    companyId: ""
  });

  const [summaryData, setSummaryData] = useState({
    total_payments: 0,
    completed_count: 0,
    pending_count: 0,
    failed_count: 0,
  });

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  // ✅ Fetch dashboard info
  const fetchDashboardData = async (companyId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}Company_Dashboard?CompanyId=${companyId}`
      );

      if (response.data) {
        setData(prev => ({
          ...prev,
          userId: response.data.userId,
          name: response.data.companyName || "Company",
          companyId: companyId
        }));
      }
    } catch (error) {
      Swal.fire("Error", "Failed to fetch dashboard data.", "error");
    }
  };

  // ✅ Fetch summary data
  const fetchSummaryData = async (companyId) => {
    try {
      if (!companyId) return;

      const payload = {
        companyId: companyId,
        type: "currentDay",
      };

      const response = await axios.post(
        `${paybridge_Url}report/company/summary`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setSummaryData(response.data.data);
      } else {
        Swal.fire("Error", "No summary data returned from API", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to fetch summary data.", "error");
    }
  };

  // ✅ Initial Load (FIXED)
  useEffect(() => {
    const init = async () => {
      const storedUserData = sessionStorage.getItem("user");

      if (!storedUserData) {
        Swal.fire("Error", "Session expired. Please login again.", "error");
        return;
      }

      const userData = JSON.parse(storedUserData);

      // ✅ CORRECT VALUE (IMPORTANT FIX)
      const companyId = userData.companyId;

      if (!companyId) {
        Swal.fire("Error", "Company ID not found.", "error");
        return;
      }

      // Set basic data from session
      setData({
        userId: userData.userId,
        name: userData.companyName || "Company",
        companyId: companyId
      });

      // Fetch APIs
      await fetchDashboardData(companyId);
      await fetchSummaryData(companyId);

      setPageLoading(false);
    };

    init();
  }, []);

  // ✅ Refresh Button
  const handleRefresh = async () => {
    if (!data.companyId) return;

    setLoading(true);
    await fetchSummaryData(data.companyId);
    setLoading(false);
  };

  // ✅ Auto Refresh (every 30 sec)
  useEffect(() => {
    if (!data.companyId) return;

    const interval = setInterval(() => {
      fetchSummaryData(data.companyId);
    }, 30000);

    return () => clearInterval(interval);
  }, [data.companyId]);

  // ✅ Page Loader
  if (pageLoading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" />
        <p>Loading Dashboard...</p>
      </div>
    );
  }

  return (
    <div className="m-4">
      <Header_Supervisor />

      <div className="card shadow mt-4">
        <div className="card-header text-center">
          <h4>
            <b>{data.name}</b> - Current Day Summary
          </h4>

          <button
            className="btn btn-outline-success mt-2"
            onClick={handleRefresh}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              "🔄 Refresh Data"
            )}
          </button>
        </div>

        <div className="card-body">
          <div className="row">

            <InfoCard title="Total Payments" value={summaryData.total_payments} />
            <InfoCard title="Completed" value={summaryData.completed_count} />
            <InfoCard title="Pending" value={summaryData.pending_count} />
            <InfoCard title="Failed" value={summaryData.failed_count} />

          </div>
        </div>
      </div>
    </div>
  );
};

// ✅ Reusable Card Component
const InfoCard = ({ title, value }) => (
  <div className="col-lg-3 col-md-6 col-6 mb-3">
    <div className="card text-center shadow-sm h-100">
      <div className="card-header fw-bold">{title}</div>
      <div className="card-body d-flex align-items-center justify-content-center">
        <h4 className="m-0">{value ?? 0}</h4>
      </div>
    </div>
  </div>
);

export default Supervisor_Dashboard;